<div class="details software-details">
  <div class="product-description">
    <label class="product-code" [innerHtml]="product.softwareTitle |searchHighlight:searchQuery"></label>
    <label class="soft-code"
    [ngStyle]="{'visibility':product&&product.softwareGroup ? 'visible':'hidden'}">{{product.softwareGroup}}</label>
    <label class="doc-text" [ngStyle]="{'visibility':product&&product.packageType ? 'visible':'hidden'}"
    [innerHtml]="product.packageType |searchHighlight:searchQuery"></label>
    <label class="doc-text"> {{product.softwareType}}</label>
    <label class="doc-desc" [innerHtml]="product.softwareDescription |searchHighlight:searchQuery"></label>
    <label class="doc-text fs-14">{{'common.text_software_search_lang_lable'|cxTranslate}}
      <span [innerHTML]="product.softwareLanguage |searchHighlight:searchQuery"></span></label>

      <label class="doc-text fs-14"><span>{{'common.text_software_search_version_lable'|cxTranslate}}</span>
      <span [innerHTML]="product.softwareVersion |searchHighlight:searchQuery"></span></label>

      @if (product?.releaseDate) {
        <label class="doc-text"
          class="fs-14"><span>{{'common.document_text_releaseDate'|cxTranslate}}</span>
          <span [innerHTML]="product.releaseDate |searchHighlight:searchQuery"></span></label>
        }

      </div>
      <div class="download-btn-outer">
        @if (product.softwareRegistration ) {
          <button class='btn btn-primary btn-block align-content-center check-avl fs-20 btn-download' [routerLink]="['/softwareRequest']"
            [queryParams]="{code:product.softwareCode}">{{'common.text_software_search_button_download_lable'|cxTranslate}}
            <img class = "hover-img whiteArrow" src="/icons/link-grey.svg">
          </button>
        } @else {
          <a class="btn btn-primary btn-block fs-20 btn-download" target="_blank" [href]="product?.softwareURL">
            {{'common.text_software_search_button_download_lable'|cxTranslate}}
            <img class = "hover-img whiteArrow" src="/icons/link-grey.svg" width="20px"></a>
          }
          <button class='btn btn-sub-primary btn-block check-avl fs-20 search-btn' [routerLink]="['/softwareDetailsPage']"
          [queryParams]="{code:product.softwareCode}">{{'common.text_software_search_button_viewdetails_lable'|cxTranslate}}</button>
        </div>
      </div>
      <ng-template [cxOutlet]="ProductListOutlets.ITEM_ACTIONS">
        <ng-container cxInnerComponentsHost></ng-container>
      </ng-template>